import moment from 'moment';
import { debug } from '../utils';

export const base64ToByteArray = async (base64String) => {
  const byteCharacters = atob(base64String);
  const byteArray = new Array(byteCharacters.length);
  for (let i = 0; i < len; i++) {
    byteArray[i] = byteCharacters.charCodeAt(i);
  }
  return new Uint8Array(byteArray);
};

/**
 * The Media API is a client-side JavaScript API that when called, prompts the user to choose files from the camera or file system of their device, which can be uploaded to your back-end server. This allows for any kind of use-case requiring file uploads, for example submitting a competition entry that requires a photo, providing legal documents, or verifying identification.
 * @param {*} type - A list of allowed MIME types for the content you want to retrieve. This can be any combination of 'image/jpeg', 'video/*', and 'application/pdf'.
 * @param {*} cameraDirection - The direction the camera should be facing when opened. The user can still choose to flip the camera direction once the camera is open. Valid inputs are 'front' and 'back'. The default value is 'back'.
 * @param {*} sources - A list of allowed sources for the content you want to retrieve. This can be 'camera', 'files', or both. If left empty, this will allow all sources.
 * @returns
 */
export const invokeGpayMediaSpotAPI = async (
  type,
  cameraDirection = 'back',
  sources
) => {
  debug('INFO', 'Initiating invokeGpayMediaSpotAPI ...');

  console.log('cameraDirection received: ', cameraDirection);

  // cameraDirection =
  //   cameraDirection === undefined ||
  //   cameraDirection === null ||
  //   cameraDirection.length === 0
  //     ? 'back'
  //     : cameraDirection;

  let typesForAPI, sourceForAPI;
  if (typeof type === 'string') {
    typesForAPI = [type];
  } else {
    typesForAPI = type;
  }

  if (typeof sources === 'string') {
    sourceForAPI = [sources];
  } else {
    sourceForAPI = sources;
  }

  sources =
    sources === undefined || sources === null || sources.length === 0
      ? 'both'
      : sources;
  const mediaRequest = {
    allowedMimeTypes: typesForAPI,
    allowedSources: sourceForAPI,
    cameraDirection,
  };

  console.log('mediaRequest: ', mediaRequest);

  const mediaAPIResponse = await microapps
    .requestMedia(mediaRequest)
    .then((response) => {
      debug('RESPONSE', `GPAY /requestMedia`, response);
      const responseToReturn = {};
      responseToReturn.statusCode = 200;
      response.bytes = response.bytes.replace(/^[^,]*,/, '');
      response.originalBytes = response.bytes;
      response.base64 = response.bytes;
      responseToReturn.body = response;
      return responseToReturn;
    })
    .catch((error) => {
      debug('ERROR', error);
      const responseToReturn = {};
      responseToReturn.statusCode = 500;
      responseToReturn.body = error;
      return responseToReturn;
    });

  debug('FINAL RETURN', `GPAY /requestMedia`, mediaAPIResponse);
  return mediaAPIResponse;
};
